<template>
  <div class="ent-history-container">
    <div class="circle font-size-26">
      <div class="start-time history-time">{{maxYear}}</div>
      <div class="end-time history-time">{{minyear}}</div>
    </div>
    <div v-for="(item,index) in dataList" :key="item.id" class="year-container clear-float">
      <div class="year-content" :class="index % 2 ? 'left':'right'">
        <div class="year font-size-26">{{item.year}}</div>
        <div class="item-container font-size-16" v-for="value in item.child" :key="value.id">
          <span class="month">{{value.month}}月</span>
          <span class="content">{{value.content}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllHonor } from "@/api";
export default {
  data() {
    return {
      maxYear: 0,
      minyear: 0,
      dataList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let res = await getAllHonor().catch(e => false);
      if (!res || res.code != 200) return;
      let list = res.data
        .map(item => {
          let date = new Date(item.obtain_time);
          return {
            id: item.honor_id,
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            content: `获得${item.honor_name}`
          };
        })
        .sort((a, b) => a.month - b.month);
      let dataList = [];
      list.forEach(item => {
        let itemObj = dataList.find(val => val.year == item.year);
        if (itemObj) {
          itemObj.child.push(item);
        } else {
          dataList.push({
            id: item.id,
            year: item.year,
            child: [item]
          });
        }
      });
      dataList.sort((a,b)=> b.year - a.year);
      this.dataList = dataList;
      if (this.dataList.length > 0) {
        this.maxYear = this.dataList[0].year;
        this.minyear = this.dataList[this.dataList.length - 1].year;
      }
    }
  }
};
</script>

<style lang="scss" scoped >
@import url("~@/assets/css/common.scss");
.ent-history-container {
  width: 100%;
  position: relative;
  padding-top: 160px;
  &::before {
    content: "";
    width: 3px;
    position: absolute;
    z-index: 5;
    left: 0;
    right: 0;
    top: 0;
    bottom: 100px;
    background-color: #336699;
    margin: auto;
  }

  .circle {
    width: 140px;
    height: 140px;
    background-color: #336699;
    overflow: hidden;
    border-radius: 50%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    z-index: 10;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      width: 1vw;
      height: 2px;
      background-color: #fff;
    }
    .history-time {
      text-align: center;
      width: 100%;
    }
    .start-time {
      margin-bottom: 2vw;
    }
  }
  .year-container {
    width: 100%;
    min-height: 113px;
    &:last-child {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 74px;
        background-color: #fff;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        border: 2px solid #336699;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 5;
        box-sizing: border-box;
      }
    }
    .year-content {
      width: 50%;
      box-sizing: border-box;
      .year {
        color: #336699;
        font-weight: bold;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 8px;
        &:after {
          content: "";
          position: absolute;
          width: 60px;
          height: 1px;
          background-color: #336699;
          top: 0;
          bottom: 0;
          margin: auto;
          z-index: 6;
        }
        &:before {
          content: "";
          position: absolute;
          width: 14px;
          height: 14px;
          background-color: #336699;
          top: 0;
          bottom: 0;
          margin: auto;
          border-radius: 50%;
          z-index: 10;
        }
      }
      .item-container {
        margin-bottom: 14px;
        .month {
          color: #336699;
          font-weight: bold;
          padding-right: 10px;
        }
        .content {
          color: #333;
          font-weight: 400;
        }
      }
    }
    .left {
      float: left;
      flex-direction: row-reverse;
      padding-right: 60px;
      text-align: right;
      .year {
        padding-right: 5px;
        &:after {
          right: -60px;
        }
        &:before {
          right: -67px;
        }
      }
      .item-container {
        padding-right: 5px;
      }
    }
    .right {
      float: right;
      padding-left: 60px;
      .year {
        padding-left: 5px;
        &:after {
          left: -60px;
        }
        &:before {
          left: -67px;
        }
      }
      .item-container {
        padding-left: 5px;
      }
    }
  }
}
</style>
